var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoWatchArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.99902C6.736 1.99902 2.25 6.48502 2.25 11.999C2.25 17.513 6.736 21.999 12.25 21.999C17.764 21.999 22.25 17.513 22.25 11.999C22.25 6.48502 17.764 1.99902 12.25 1.99902ZM18 12.999H11.25V5.99902H13.25V10.999H18V12.999Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWatchArrows);
export default __webpack_public_path__ + "static/media/ico-watch-arrows.4dc450d8279d2c657c9ce91308b41697.svg";
export { ForwardRef as ReactComponent };